import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ChartBarIcon, 
  GlobeAltIcon, 
  ArrowPathIcon, 
  ArrowTopRightOnSquareIcon,
  EnvelopeIcon
} from '@heroicons/react/24/outline';

const toolkitItems = [
  {
    id: 'peoplemetrics',
    name: 'Peoplemetrics',
    description: 'Scale-up people & talent benchmarks for data-driven chief people officers.',
    icon: <ChartBarIcon className="h-8 w-8 text-primary" />,
    externalUrl: 'https://peoplemetrics.fyi',
    bgColor: 'from-blue-500/10 to-purple-500/10',
    color: 'text-blue-400',
    badge: 'Marketplace Discount Available',
    badgeColor: 'bg-primary/20 text-primary'
  },
  {
    id: 'openverse',
    name: 'Openverse',
    description: 'Discover, launch and get feedback on your People team\'s next big thing.',
    icon: <GlobeAltIcon className="h-8 w-8 text-primary" />,
    externalUrl: 'https://openverse.fyi',
    bgColor: 'from-green-500/10 to-teal-500/10',
    color: 'text-teal-400',
    badge: 'Free Community Product',
    badgeColor: 'bg-green-500/20 text-green-400'
  },
  {
    id: 'openloop',
    name: 'Open Loop',
    description: 'Feedback and continuous improvement system for open organizations',
    icon: <ArrowPathIcon className="h-8 w-8 text-primary" />,
    externalUrl: 'https://openloop.fyi',
    bgColor: 'from-amber-500/10 to-orange-500/10',
    color: 'text-amber-400',
    badge: 'Coming Soon',
    badgeColor: 'bg-gray-500/20 text-gray-400'
  },
  {
    id: 'openworks',
    name: 'Open Works',
    description: 'Our weekly newsletter where we crowd-source people and culture problems and solutions.',
    icon: <EnvelopeIcon className="h-8 w-8 text-primary" />,
    externalUrl: 'https://news.openorg.fyi',
    bgColor: 'from-purple-500/10 to-pink-500/10',
    color: 'text-purple-400',
    badge: 'Weekly Newsletter',
    badgeColor: 'bg-purple-500/20 text-purple-400'
  }
];

const Toolkit = () => {
  const addUTMParameters = (url) => {
    if (!url) return url;
    
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('utm_source', 'membership.openorg.fyi');
      urlObj.searchParams.set('utm_medium', 'referral');
      urlObj.searchParams.set('utm_campaign', 'toolkit');
      urlObj.searchParams.set('utm_content', 'toolkit_page');
      return urlObj.toString();
    } catch (error) {
      console.warn('Invalid URL for UTM parameters:', url);
      return url;
    }
  };

  // Generate URL-friendly slug from name
  const generateSlug = (name) => {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  return (
    <div className="w-full mx-auto max-w-7xl">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3">Open Org Toolkit</h1>
        <p className="text-gray-400 text-lg max-w-3xl">
          Things we've built to help you have a greater impact as a People Leader. 
        </p>
      </div>

      {/* Main cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {toolkitItems.map((tool) => (
          <div 
            key={tool.id}
            className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-200"
          >
            <div className={`bg-gradient-to-br ${tool.bgColor} p-6 relative overflow-hidden`}>
              <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-white/5 blur-xl"></div>
              <div className="flex items-start justify-between mb-4">
                {tool.icon}
                {tool.badge === 'Marketplace Discount Available' ? (
                  <Link 
                    to="/marketplace/peoplemetrics-fyi"
                    className={`text-xs font-medium px-2 py-1 rounded-full ${tool.badgeColor} hover:bg-primary/30 transition-colors cursor-pointer`}
                  >
                    {tool.badge}
                  </Link>
                ) : (
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${tool.badgeColor}`}>
                    {tool.badge}
                  </span>
                )}
              </div>
              <h3 className="text-xl font-bold text-white mb-1">{tool.name}</h3>
              <div className={`text-sm ${tool.color}`}>
                {tool.externalUrl.replace('https://', '')}
              </div>
            </div>
            <div className="p-6">
              <p className="text-gray-300 mb-6">{tool.description}</p>
              <div className="flex space-x-3">
                {tool.id === 'openloop' ? (
                  <button
                    disabled
                    className="px-4 py-2 bg-gray-700 text-gray-400 rounded-md text-sm font-medium cursor-not-allowed flex items-center flex-1 justify-center"
                  >
                    Coming Soon
                  </button>
                ) : (
                  <a 
                    href={addUTMParameters(tool.externalUrl)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-primary hover:bg-primary-dark text-white rounded-md text-sm font-medium transition-colors flex items-center flex-1 justify-center"
                  >
                    Visit Site
                    <ArrowTopRightOnSquareIcon className="h-4 w-4 ml-1" />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

     

    </div>
  );
};

export default Toolkit; 